import * as React from 'react';
export const createIdentityVerificationSvg = React.forwardRef(
  function createIdentityVerificationSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M2.75 0A2.75 2.75 0 0 0 0 2.75v2.5a.75.75 0 0 0 1.5 0v-2.5c0-.69.56-1.25 1.25-1.25h2.5a.75.75 0 0 0 0-1.5h-2.5ZM1.5 10.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 2.75 16h2.5a.75.75 0 0 0 0-1.5h-1.2a2.5 2.5 0 0 1 2.45-2h3a2.5 2.5 0 0 1 2.45 2h-1.2a.75.75 0 0 0 0 1.5h2.5A2.75 2.75 0 0 0 16 13.25v-2.5a.75.75 0 0 0-1.5 0v2.5a1.25 1.25 0 0 1-1.033 1.231A4 4 0 0 0 9.5 11h-3a4 4 0 0 0-3.967 3.481A1.25 1.25 0 0 1 1.5 13.25v-2.5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8 3.25a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Zm-.972 1.795a1.75 1.75 0 1 1 1.944 2.91 1.75 1.75 0 0 1-1.944-2.91Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M13.25 0a.75.75 0 0 1 .75.75V2h1.25a.75.75 0 0 1 0 1.5H14v1.25a.75.75 0 0 1-1.5 0V3.5h-1.25a.75.75 0 0 1 0-1.5h1.25V.75a.75.75 0 0 1 .75-.75Z',
      }),
    );
  },
);
createIdentityVerificationSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var createIdentityVerification = {
  category: 'icon',
  colorable: true,
  name: 'createIdentityVerification',
  svg: createIdentityVerificationSvg,
};
